import { render, staticRenderFns } from "./food-class-list.vue?vue&type=template&id=2b5a698c&scoped=true&"
import script from "./food-class-list.vue?vue&type=script&lang=js&"
export * from "./food-class-list.vue?vue&type=script&lang=js&"
import style0 from "./food-class-list.vue?vue&type=style&index=0&id=2b5a698c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a698c",
  null
  
)

export default component.exports